module.exports = __webpack_public_path__ + "img/medical_middle.16565e2a.jpg";